<template>
	<b-form-row>
		<b-col cols="2" @click="playAudio()">
			<b-avatar rounded size="4rem" :src="value&&value.md5&&value.mime&&value.mime[0]=='image'&&value.url||null" :icon="value&&value.mime&&value.mime[0]=='audio'&&(playing?'stop':'play')||''"></b-avatar>
		</b-col>
		<b-col>
			<b-form-file @change="onChange($event)" :accept="accept"></b-form-file><br />
			<span v-if="value && value.md5">{{value.filename}} ({{bytesString(value.size)}}B)</span>
		</b-col>
	</b-form-row>
</template>

<script>
import util from '@/util.js';

export default {
	name: 'PipiPupuFile',
	data() { return {
		file: null,
		audio: null,
		playing: false,
	}},
	props: {
		accept: String,
		value: Object,
	},
	beforeDestroy() {
		this.audio?.pause?.();
	},
	methods: {
		onChange($event) {
			this.audio?.pause?.();
			if(!$event.target.files || !$event.target.files[0]) return;

			this.$api.uploadFile($event.target.files[0].name, $event.target.files[0]).then(result => {
				this.$emit('input', result);
			}).catch(err => console.error('Could not upload file', err));
		},
		playAudio() {
			if(this.value?.mime?.[0] != 'audio') return;
			if(!this.value.url) return;
			if(this.audio) return this.audio.pause();
			this.audio = new Audio(this.value.url);
			this.audio.addEventListener('ended', () => {
				this.playing = false;
				this.audio = null;
			})
			this.audio.addEventListener('pause', () => {
				this.playing = false;
				this.audio = null;
			})
			this.audio.addEventListener('canplaythrough', () => {
				this.audio.play();
				this.playing = true;
			});
		},
		bytesString(n) {
			return util.bytesString(n);
		},
	}
};
</script>

<style>
	.pipipupufile-preview {
		max-width: 128px;
		max-height: 128px;
	}
</style>
